import { useSearchParams } from 'react-router-dom';
import { CheckCircle, XCircle } from 'lucide-react';

export function UnsubscribedPage() {
  const [params] = useSearchParams();
  const email = params.get('email');
  const error = params.get('error');

  if (error === 'invalid') {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center p-4">
        <div className="w-full max-w-md">
          <div className="bg-background-card rounded-xl p-8 shadow-lg border border-border text-center">
            <div className="flex justify-center mb-6">
              <div className="w-16 h-16 bg-destructive/10 rounded-full flex items-center justify-center">
                <XCircle className="w-8 h-8 text-destructive" />
              </div>
            </div>
            <h1 className="text-2xl font-bold text-text-primary mb-2">Invalid link</h1>
            <p className="text-text-secondary">
              This unsubscribe link is invalid or has already been used.
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="bg-background-card rounded-xl p-8 shadow-lg border border-border text-center">
          <div className="flex justify-center mb-6">
            <div className="w-16 h-16 bg-success/10 rounded-full flex items-center justify-center">
              <CheckCircle className="w-8 h-8 text-success" />
            </div>
          </div>
          <h1 className="text-2xl font-bold text-text-primary mb-2">You're unsubscribed</h1>
          {email && (
            <p className="text-text-secondary mb-1">
              <span className="font-medium text-text-primary">{email}</span> will no longer
              receive marketing emails from us.
            </p>
          )}
          <p className="text-sm text-text-secondary mt-3">
            You'll still receive emails about your account and invites. You can close this page.
          </p>
        </div>
      </div>
    </div>
  );
}
